// TutorLayout — sidebar nav + shell for the tutor role (rendered by the shared AppShell).
import AppShell, { type NavItem } from "./AppShell.js";

const NAV_ITEMS: readonly NavItem[] = [
  { to: "/app/tutor",            label: "Dashboard",  end: true },
  { to: "/app/tutor/courses",    label: "Courses",    end: false },
  { to: "/app/tutor/sessions",   label: "Sessions",   end: false },
  { to: "/app/tutor/attendance", label: "Attendance", end: false },
  { to: "/app/tutor/roster",     label: "Roster",     end: false },
  { to: "/app/tutor/profile",    label: "Profile",    end: false },
];

export default function TutorLayout() {
  return <AppShell title="Tutor" items={NAV_ITEMS} />;
}
